import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfEspecie } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfEspecie = {
	ORGAO: '',
	DESCRICAO: '',
};

export const useListEspecieController = () => {
	const [EspecieData, setEspecieData] = useState<ModelOfEspecie[]>([]);
	const [selectedEspecie, setSelectedEspecie] = useState<ModelOfEspecie>(initialValuesOfEspecie);
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getEspecie = () => {
		api.get(`especies/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setEspecieData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeEspecie = (Especie: ModelOfEspecie) => {
		setLoading(true);
		api.delete(`especies/${Especie.ID}`)
			.then(() => {
				getEspecie();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A espécie de veículo foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getEspecie();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editEspecie = (Especie: ModelOfEspecie) => {
		setLoading(true);

		const editedEspecie: ModelOfEspecie = {
			...Especie,
			ORGAO: userAgencyId,
		};

		api.put(`especies/${selectedEspecie?.ID}`, editedEspecie)
			.then(() => {
				getEspecie();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A espécie de veículo foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getEspecie();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getEspecie();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	const openDeleteDialog = (Especie: ModelOfEspecie) => {
		setDeleteDialog(true);
		setSelectedEspecie(Especie);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Especie: ModelOfEspecie) => {
		setEditDialog(true);
		setSelectedEspecie(Especie);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfEspecie>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: async values => await editEspecie(values),
		validationSchema,
	});

	return {
		getEspecieListController: {
			formik,
			EspecieData,
			selectedEspecie,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleEspecieListController: {
			removeEspecie,
			editEspecie,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
		},
	};
};
